export default "__VITE_ASSET__f7e6ce40__"